// eslint-disable-next-line no-shadow
export var EHubDetailMutations;
(function (EHubDetailMutations) {
    EHubDetailMutations["GET_HUB_INFO"] = "GET_HUB_INFO";
    EHubDetailMutations["RESET_HUB_INFO"] = "RESET_HUB_INFO";
})(EHubDetailMutations || (EHubDetailMutations = {}));
